import {KetQuaChiaGio, LichChiaGio} from '@/models/ketQuaChiaGio';

export interface DongLichNhanVien {
  nhanVienId:number; tenNhanVien:string; vaiTro:'Chính'|'Phụ'; phoiHop:string; lich:LichChiaGio;
}
export interface TongHopNhanVien {
  nhanVienId:number; tenNhanVien:string; tongDichVu:number; soChinh:number; soPhu:number; tongPhut:number; sang:number; chieu:number;
}
export function taoLichNhanVien(result:KetQuaChiaGio):DongLichNhanVien[] {
  const rows:DongLichNhanVien[]=[];
  result.daXepLich.forEach(lich=>{
    rows.push({nhanVienId:lich.nhanVienId,tenNhanVien:lich.tenNhanVien||`Nhân viên ${lich.nhanVienId}`,vaiTro:'Chính',phoiHop:lich.tenNhanVienPhu||'',lich});
    if(lich.nhanVienPhuId!=null&&lich.nhanVienPhuId!==lich.nhanVienId)
      rows.push({nhanVienId:lich.nhanVienPhuId,tenNhanVien:lich.tenNhanVienPhu||`Nhân viên ${lich.nhanVienPhuId}`,vaiTro:'Phụ',phoiHop:lich.tenNhanVien||'',lich});
  });
  return rows.sort((a,b)=>a.tenNhanVien.localeCompare(b.tenNhanVien,'vi')||a.nhanVienId-b.nhanVienId||a.lich.thoiGianBatDau.localeCompare(b.lich.thoiGianBatDau)||a.lich.dichVuYeuCauId-b.lich.dichVuYeuCauId);
}
export function tongHopNhanVien(result:KetQuaChiaGio):TongHopNhanVien[] {
  const people=new Map<number,TongHopNhanVien>();
  const add=(id:number,name:string)=>{
    if(!people.has(id))people.set(id,{nhanVienId:id,tenNhanVien:name||`Nhân viên ${id}`,tongDichVu:0,soChinh:0,soPhu:0,tongPhut:0,sang:0,chieu:0});
    return people.get(id)!;
  };
  (result.nhanViens||[]).forEach(x=>add(x.nhanVien_Id,x.tenNhanVien));
  taoLichNhanVien(result).forEach(row=>{
    const person=add(row.nhanVienId,row.tenNhanVien);
    person.tongDichVu++;person.tongPhut+=row.lich.thoiGianThucHien;
    if(row.vaiTro==='Chính')person.soChinh++;else person.soPhu++;
    if(Number(row.lich.thoiGianBatDau.slice(11,13))<12)person.sang++;else person.chieu++;
  });
  return [...people.values()].sort((a,b)=>a.tenNhanVien.localeCompare(b.tenNhanVien,'vi')||a.nhanVienId-b.nhanVienId);
}
